
// Employee.jsx
import React, { useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout} from "../features/auth/authSlice";
import EmployeeStatusBadge from "./EmployeeStatusBadge";
import EmployeeAvatar from "./EmployeeAvatar";
import { Button, Card, Col, Row, Container } from "react-bootstrap";
import { Typography } from "@mui/material";

const Employee = React.memo( ({ employee, handleEmployeeClick}) => {
  const { user, isSuccessAuth } = useSelector((state) => state.auth);

  return (
        <div style={{ position: "relative" }}>
          <Row className="px-0 px-lg-5 d-flex h-100 align-items-center justify-content-center">
            <EmployeeAvatar 
              employee={employee} 
              isSuccessAuth={isSuccessAuth}
            />
            <EmployeeStatusBadge 
              employee={employee} 
            />
          </Row>
        </div>
  );
});

export default Employee;

